import React, { ComponentType, useEffect, useRef } from 'react';
import TemplateModalWithButton from 'src/components/TemplateModalWithButton/TemplateModalWithButton';
import { SeedInfoSelections, titledModalQaSelector } from 'src/components/Mfp/MfpScopeSelector/MfpScopebar.types';
import { PlanId } from 'src/state/scope/codecs/PlanMetadata';
import { useHandleEscapePress } from 'src/utils/Component/hooks/hooks';
import { AutocompleteOption } from '../PlanMetadataGrid/PlanMetadataGrid.utils';

interface VisibilityProp {
  isVisible: boolean;
}

export interface ScopebarOptionModalProps {
  modalTitle: string;
  modalClassName: string;
  modalDataQa?: string | undefined;
  modalBodyComponent: ComponentType<any>;
  modalBodyComponentProps: ModalBodyComponentProps;
}

export interface ModalBodyComponentProps {
  copyPeriod?: string;
  copyPeriodOptions?: AutocompleteOption[];
  copyVersion?: PlanId | string;
  copyVersionOptions?: AutocompleteOption[];
  loading: boolean;
  onItemChange: (field: SeedInfoSelections, value?: number | string) => void;
  onCancel?: () => void;
  onSubmit?: (id?: number) => void;
  onOpen?: () => void;
}

const ScopebarOptionModal = (props: VisibilityProp & ScopebarOptionModalProps) => {
  const { modalTitle, isVisible, modalClassName, modalDataQa, modalBodyComponent, modalBodyComponentProps } = props;

  const ModalBody = modalBodyComponent;
  const dataQaSuffix = modalDataQa ? `-${modalDataQa}` : '';
  const dataQa = `${titledModalQaSelector}${dataQaSuffix}`;
  const getDivRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (getDivRef.current !== null) {
      getDivRef.current.focus();
    }
  }, [getDivRef, isVisible]);
  const handleEscapePress = useHandleEscapePress(modalBodyComponentProps);
  return (
    <div ref={getDivRef} onKeyDown={handleEscapePress} tabIndex={-1} data-qa={dataQa}>
      {isVisible && (
        <TemplateModalWithButton
          title={modalTitle}
          buttonComponent={<span style={{ display: 'none' }} />} // hidden dummy trigger
          showSubmit={false}
          openOverride={true}
          onCancel={modalBodyComponentProps.onCancel}
          paperClassName={modalClassName}
        >
          <ModalBody {...modalBodyComponentProps} />
        </TemplateModalWithButton>
      )}
    </div>
  );
};

export default ScopebarOptionModal;
